angular.module('iw.frontyard.signup')
    .controller('CustomerSignupController', function ($scope,
                                                      $rootScope,
                                                      SignupPage,
                                                      IwocaSiteHelper) {

        $scope.signup = SignupPage;
        $scope.IwocaSiteHelper = IwocaSiteHelper;

        $rootScope.openSignupOverlayAsDefault = function () {
            SignupPage.setAsDefaultProduct();
            $scope.$digest();
            IwocaSiteHelper.openSignupOverlay();
        };

        $rootScope.openSignupOverlayAsCreditLine = function () {
            SignupPage.setAsCreditLineProduct();
            $scope.$digest();
            IwocaSiteHelper.openSignupOverlay();
        };

        $rootScope.openSignupOverlayAsTermLoan = function () {
            SignupPage.setAsTermLoanProduct();
            $scope.$digest();
            IwocaSiteHelper.openSignupOverlay();
        };

    });
